module.exports = __webpack_public_path__ + "img/jkjshfu.e3affda.png";